import styled from "styled-components";
export const ContainerTable = styled.div<{
  children: JSX.Element | JSX.Element[] | React.ReactNode | any;
}>`
  margin-top: 20px;
`;

export const DivButtonExportFile = styled.div<{
  children: any;
}>`
  display: flex !important;
  justify-content: flex-end;
  margin-bottom: 5px
`;

export const ContainerSearch = styled.div<{
  children: any;
}>`
  height: 20px;
  display: flex;
  margin: 20px 0px;
  justify-content: flex-end;
`;

export const ContainerData = styled.div<{
  children: JSX.Element | JSX.Element[] | React.ReactNode | any;
}>`
  display: block !important;
  width: 80% !important;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
`;
